// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ConstructionDocumentPickerDocumentsQueryVariables = Types.Exact<{
  filter: Types.DocumentsFilter;
  page: Types.PageFilter;
}>;


export type ConstructionDocumentPickerDocumentsQuery = { __typename?: 'Query', documents: { __typename?: 'DocumentsPageResult', entities: Array<{ __typename?: 'Document', id: string, name: string, asset: { __typename?: 'Asset', id: string } }> } };


export const ConstructionDocumentPickerDocumentsDocument = gql`
    query ConstructionDocumentPickerDocuments($filter: DocumentsFilter!, $page: PageFilter!) {
  documents: documentsPage(filter: $filter, page: $page) {
    entities {
      id
      name
      asset {
        id
      }
    }
  }
}
    `;

/**
 * __useConstructionDocumentPickerDocumentsQuery__
 *
 * To run a query within a React component, call `useConstructionDocumentPickerDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConstructionDocumentPickerDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConstructionDocumentPickerDocumentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useConstructionDocumentPickerDocumentsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ConstructionDocumentPickerDocumentsQuery, ConstructionDocumentPickerDocumentsQueryVariables> & ({ variables: ConstructionDocumentPickerDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ConstructionDocumentPickerDocumentsQuery, ConstructionDocumentPickerDocumentsQueryVariables>(ConstructionDocumentPickerDocumentsDocument, options);
      }
export function useConstructionDocumentPickerDocumentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ConstructionDocumentPickerDocumentsQuery, ConstructionDocumentPickerDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ConstructionDocumentPickerDocumentsQuery, ConstructionDocumentPickerDocumentsQueryVariables>(ConstructionDocumentPickerDocumentsDocument, options);
        }
// @ts-ignore
export function useConstructionDocumentPickerDocumentsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ConstructionDocumentPickerDocumentsQuery, ConstructionDocumentPickerDocumentsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ConstructionDocumentPickerDocumentsQuery, ConstructionDocumentPickerDocumentsQueryVariables>;
export function useConstructionDocumentPickerDocumentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ConstructionDocumentPickerDocumentsQuery, ConstructionDocumentPickerDocumentsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ConstructionDocumentPickerDocumentsQuery | undefined, ConstructionDocumentPickerDocumentsQueryVariables>;
export function useConstructionDocumentPickerDocumentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ConstructionDocumentPickerDocumentsQuery, ConstructionDocumentPickerDocumentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ConstructionDocumentPickerDocumentsQuery, ConstructionDocumentPickerDocumentsQueryVariables>(ConstructionDocumentPickerDocumentsDocument, options);
        }
export type ConstructionDocumentPickerDocumentsQueryHookResult = ReturnType<typeof useConstructionDocumentPickerDocumentsQuery>;
export type ConstructionDocumentPickerDocumentsLazyQueryHookResult = ReturnType<typeof useConstructionDocumentPickerDocumentsLazyQuery>;
export type ConstructionDocumentPickerDocumentsSuspenseQueryHookResult = ReturnType<typeof useConstructionDocumentPickerDocumentsSuspenseQuery>;
export type ConstructionDocumentPickerDocumentsQueryResult = ApolloReactCommon.QueryResult<ConstructionDocumentPickerDocumentsQuery, ConstructionDocumentPickerDocumentsQueryVariables>;